<template>
    <div>
        <Header/>
        <nuxt/>
        <Footer/>
        <Svgs/>
    </div>
</template>

<script>
import Window from '~/mixins/window';
import Fallback from '~/mixins/fallback';

import Header from '~/components/Layout/Header';
import Footer from '~/components/Layout/Footer';
import Svgs from '~/components/Svgs';

export default {
    components: {
        Header,
        Footer,
        Svgs
    },
    mixins: [Window, Fallback],
    mounted() {
        this.initWindow();
        this.initFallbacks();
    },
    destoyed() {
        this.destroyWindow();
    }
};
</script>
